import { useEffect } from "react";

// Custom hook that updates the theme color meta tag
const useThemeColor = (selector = ".background", updateInterval = 50) => {
  useEffect(() => {
    const targetElement = document.querySelector(selector);

    if (!targetElement) {
      console.warn(`Element with selector "${selector}" not found.`);
      return;
    }

    function updateAppColor() {
      const computedStyle = getComputedStyle(targetElement);
      const bgColor = computedStyle.backgroundColor;

      document.documentElement.style.setProperty("--app-background", bgColor);
    }

    const intervalId = setInterval(updateAppColor, updateInterval);
    return () => clearInterval(intervalId);
  }, [selector, updateInterval]);
};

export default useThemeColor;
